const LOADER_KEY = 'sx-loader-seen';

/* The shape loader plays on a first visit only, never on a reload within the same session. */
export function shouldPlayLoader(): boolean {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    try {
        return !window.sessionStorage.getItem(LOADER_KEY);
    } catch {
        return true;
    }
}

export function markLoaderSeen() {
    try {
        window.sessionStorage.setItem(LOADER_KEY, '1');
    } catch {
        // Storage can be blocked (private windows); the loader then simply plays again.
    }
}
